import React, { useState } from 'react';
import './SharePanel.css';

const SharePanel = ({ shareId, label = 'Share PDF' }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${window.location.origin}${window.location.pathname || '/'}?share=${shareId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="share-panel">
      <span className="share-panel-label">{label}</span>
      <div className="share-panel-row">
        <input
          type="text"
          readOnly
          value={shareUrl}
          className="share-url-input"
          aria-label="Share link"
        />
        <button type="button" className="share-copy-btn" onClick={handleCopy}>
          {copied ? '✓ Copied' : 'Copy link'}
        </button>
      </div>
      {copied && (
        <div className="share-tooltip" role="status">
          Link copied to clipboard!
        </div>
      )}
    </div>
  );
};

export default SharePanel;





